import PropTypes from 'prop-types';
import { useMutation, useApolloClient } from '@apollo/client';
import DietMealReplaceProductMutation from './DietMealReplaceProductMutation';
import optimisticResponse from './ReplaceProductOptimisticResponse';
import clearDailyDietPlanCacheObjects from '../../../Apollo/clearDailyDietPlanCacheObjects';

const DietMealReplaceProductConnectorApollo = ({ children }) => {
  const client = useApolloClient();

  const [replaceProduct, { data, loading, error }] = useMutation(DietMealReplaceProductMutation);

  const createReplaceProduct = async ({
    productAmountId,
    replacementId,
    productId,
    name,
    measurements,
  }) => {
    const response = await replaceProduct({
      variables: {
        productAmountId,
        replacementId,
      },
      optimisticResponse,
      update: (cache) => {
        const cachedProductToFindById = {
          __typename: 'DietDishIngredient',
          productId,
        };

        cache.modify({
          id: cache.identify(cachedProductToFindById),
          fields: {
            name() {
              return name;
            },
            measurements() {
              return measurements;
            },
          },
          broadcast: true,
        });
      },
    });

    if (response.data.me.dietMealReplaceProduct.__typename !== 'BasicMutationSuccess') {
      throw new Error(
        `Replace product failed: ${response.data.me.dietMealReplaceProduct.__typename}`
      );
    }

    clearDailyDietPlanCacheObjects(client);
  };

  return children({
    replaceProduct: {
      replace: createReplaceProduct,
      response: data,
      loading,
      error,
    },
  });
};

DietMealReplaceProductConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default DietMealReplaceProductConnectorApollo;
